import { useEffect, useRef, useState } from 'react';
import { BordOneToneIcon } from 'components/NudosComponents';
import './OrderActionsDropdown.scss';

interface IOrderActionsDropdownProps {
  onOpenCancelModal: () => void;
  isCancelDisabled?: boolean;
}

const OrderActionsDropdown = ({
  onOpenCancelModal,
  isCancelDisabled
}: IOrderActionsDropdownProps) => {
  const [isOpen, setIsOpen] = useState(false);
  const containerRef = useRef<HTMLDivElement>(null);
  const handleToggle = () => setIsOpen(prev => !prev);

  const handleSelectCancel = () => {
    setIsOpen(false);
    onOpenCancelModal();
  };

  const createClickOutsideHandler = (
    isOpen: boolean,
    containerRef: React.RefObject<HTMLDivElement | null>,
    onClose: () => void
  ) => {
    return (event: MouseEvent) => {
      const target = event.target;
      const isOutside =
        isOpen &&
        containerRef.current &&
        target instanceof Node &&
        !containerRef.current.contains(target);

      if (isOutside) onClose();
    };
  };

  const handleClickOutside = createClickOutsideHandler(isOpen, containerRef, () => setIsOpen(false));

  useEffect(() => {
    document.addEventListener('mousedown', handleClickOutside);
    return () => document.removeEventListener('mousedown', handleClickOutside);
  }, [isOpen, handleClickOutside]);

  return (
    <div className="orderActionsDropdownWrapper" ref={containerRef}>
      <button
        type="button"
        className="orderActionsMenuTrigger"
        onClick={handleToggle}
        aria-label="Abrir menú de acciones"
      >
        <BordOneToneIcon variant="extra" standardSize={38}/>
      </button>
      {isOpen && (
        <div className="orderActionsDropdownMenu">
          <button
            type="button"
            className="orderActionsDropdownItem"
            onClick={handleSelectCancel}
            disabled={isCancelDisabled}
          >
            Cancelar
          </button>
        </div>
      )}
    </div>
  );
};

export default OrderActionsDropdown;
